import React from 'react';

import { Heading5 } from '../../../../../theme';
import { StyledTotalLine, FineDetails, Block } from '../style';

type TotalItemProps = {
    item: string;
    amount: string;
};
export default function TotalItem({ item, amount }: TotalItemProps) {
    return (
        <>
            <StyledTotalLine />
            <FineDetails>
                <Heading5>{item}</Heading5>
                <Block>
                    <Heading5>
                        {amount}                        
                    </Heading5>
                </Block>
            </FineDetails>
            <StyledTotalLine />
        </>
    );
}
